import React, { Component } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { isEqual } from 'lodash';
import { getCropBasedMessage, getMessage } from 'util/locale';
import { formatNumSeedBags } from 'util/formatters/numberFormatter';
import { convertForLocale, parseDecimals } from 'util/unitConversion';
import { bagText } from 'util/bagText';
import { cropIds } from 'constants/crops';

import ValueWithHeader from 'common/ValueWithHeader';
import { Icon, TooltipWrapper, ALIGNMENTS } from '@tcc/crate';
import { isEmeaCountry } from 'constants/countryCodes';

const baseString = 'vra-product-summary';
const classString = classNames({
  [`${baseString}`]: true,
  'vra-seed-summary': true
});
class SeedSummary extends Component {
  shouldComponentUpdate(nextProps) {
    return !isEqual(nextProps.summary, this.props.summary);
  }

  render() {
    const {
      accountCountry,
      bagSize,
      cropId,
      summary
    } = this.props;

    let seedStats = summary.map((seed, index) => {
      const product = seed.product || {
        name: getCropBasedMessage({ key: 'text__none-entered', cropId })
      };

      const avgPop = convertForLocale({
        quantity: seed.avgRate.q,
        unit: seed.avgRate.u,
        unitType: 'seed-density.seed-density-short',
        precision: 2
      });
      avgPop.scalarLocaleString = parseDecimals(avgPop.scalarLocaleString);

      const isCorn = String(cropId) === String(cropIds.CORN);
      return (
        <ul className={`${baseString}__list`} key={`seed-summary-seed-${index}`}>
          <li
            className={`${baseString}__list__item`}
            data-test-id={'seed-summary-product'}
            key={`seed-summary-product-${index}`}>
            <ValueWithHeader
              header={product.brand}
              subheader={getMessage(`${seed.crop}-product`)}
              value={product.name}
            />
          </li>
          <li
            className={`${baseString}__list__item`}
            data-test-id={'seed-summary-average-pop'}
            key={`seed-summary-avg-rate-${index}`}>
            <ValueWithHeader
              header={getMessage('title-text__avg-population--short')}
              value={avgPop.toString({ fullName: false })}
            />
          </li>
          <li
            className={`${baseString}__list__item`}
            data-test-id={'seed-summary-num-bags'}
            key={`seed-summary-num-seed-bags-${index}`}>
            <div className={`${baseString}__list__item__seed-bags`}>
              <ValueWithHeader
                header={getMessage('title-text__seed-bags--short')}
                value={bagText(accountCountry, formatNumSeedBags(seed.numSeedBags.q), cropId)}
              />
              {isCorn && isEmeaCountry(accountCountry) && <TooltipWrapper
                alignment={ALIGNMENTS.CENTER}
                content={[getMessage('text__script-seed-bag-info', {bagSize})]}
                placement='top'
              >
                <a>
                  <Icon className='warning-icon' glyph={Icon.set.INFO_CIRCLE}/>
                </a>
              </TooltipWrapper>}
            </div>
          </li>
        </ul>
      );
    });

    return (
      <section className={classString}>
        {seedStats}
      </section>
    );
  }
}

SeedSummary.propTypes = {
  accountCountry: PropTypes.string.isRequired,
  bagSize: PropTypes.number.isRequired,
  cropId: PropTypes.number.isRequired,
  summary: PropTypes.array.isRequired
};
export default SeedSummary;
